import { render, staticRenderFns } from "./FontPicker.vue?vue&type=template&id=570905cc&scoped=true"
import script from "./FontPicker.vue?vue&type=script&lang=js"
export * from "./FontPicker.vue?vue&type=script&lang=js"
import style0 from "./FontPicker.vue?vue&type=style&index=0&id=570905cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570905cc",
  null
  
)

export default component.exports